(function () {
  if (!document.body.classList.contains('template-product')) return;

  var section = document.querySelector('[data-section-type="product"]');
  if (!section) return;

  var photos = section.querySelector('[data-product-photos]');
  var thumbs = section.querySelector('[data-product-thumbs]');
  var stickyImg = section.querySelector('[data-valor-sticky-image]');
  var counter = section.querySelector('[data-valor-gallery-counter]');

  function getActiveIndex() {
    if (!photos) return 0;
    var active = photos.querySelector('.product-main-slide.is-selected, .product-main-slide[aria-hidden="false"]');
    if (!active) active = photos.querySelector('.product-main-slide');
    if (!active) return 0;
    var slides = photos.querySelectorAll('.product-main-slide');
    return Array.prototype.indexOf.call(slides, active);
  }

  function getTotalSlides() {
    if (!photos) return 0;
    return photos.querySelectorAll('.product-main-slide').length;
  }

  function updateCounter() {
    if (!counter) return;
    var total = getTotalSlides();
    var index = getActiveIndex();
    if (total <= 1) {
      counter.hidden = true;
      return;
    }
    counter.hidden = false;
    counter.textContent = (index + 1) + ' / ' + total;
  }

  function updateStickyImage() {
    if (!stickyImg) return;
    var activeThumb = thumbs && thumbs.querySelector('.product__thumb-item a.is-active');
    var activeSlide = photos && photos.querySelector('.product-main-slide.is-selected img, .product-main-slide[aria-hidden="false"] img');
    var src = null;
    if (activeThumb) {
      var thumbImg = activeThumb.querySelector('img');
      if (thumbImg) src = thumbImg.currentSrc || thumbImg.src;
    }
    if (!src && activeSlide) src = activeSlide.currentSrc || activeSlide.src;
    if (src) stickyImg.src = src;
  }

  if (photos) {
    var observer = new MutationObserver(function () {
      updateCounter();
      updateStickyImage();
    });
    observer.observe(photos, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-hidden', 'src'] });
  }

  if (thumbs) {
    thumbs.addEventListener('click', function () {
      window.setTimeout(function () {
        updateCounter();
        updateStickyImage();
      }, 80);
    });
  }

  document.addEventListener('variant:change', updateStickyImage);
  updateCounter();
  updateStickyImage();
})();
